import { render, staticRenderFns } from "./Fase2.vue?vue&type=template&id=3b78101f&scoped=true"
import script from "./Fase2.vue?vue&type=script&lang=js"
export * from "./Fase2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78101f",
  null
  
)

export default component.exports